import type { AuthUser } from "../../../stores/useAuthStore";

/** Best-effort JWT payload parse. Only for reading token metadata (e.g. `exp`) — never for identity; the claims carry no email or name. */
export function decodeJwtClaims(token: string): AuthUser | null {
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((char) => `%${(`00${char.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join(""),
    );
    return JSON.parse(json) as AuthUser;
  } catch {
    return null;
  }
}
